import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { PostThemeEnum } from '~/api/blog/blogTypes';
import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { BlogsPage } from '~/atomic/page/blogs/BlogsPage';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { getPosts } from '~/feature/blogs/blog.data';
import { getPagingFromUrl } from '~/feature/pagination/pagination.data';
import { BlogTemplate } from '~/feature/template/BlogTemplate';
import { createStore, RootState } from '~/store';

const Blogs:NextPage & LayoutType = () => {
  const title = 'Блоги | Произведения авторов полностью на Bookriver';
  const description = 'Блоги — литературно-издательская площадка Bookriver'
  + ' ⭐ Серии книг ⭐ Полные циклы произведений'
  + ' ⭐ Комментарии и отзывы читателей ⭐ Скачать произведения'
  + ' полностью в формате fb2 ✉ Найдите интересную'
  + ' книгу на нашем сайте и читайте удобно онлайн';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.blogs.isPublic}
      seo={{
        title,
        description,
        canonical: pagesConfigStore.blogs.url,
      }}
      content={(
        <BlogsPage />
      )}
    />
  );
};

Blogs.getLayout = (page) => (
  <BlogTemplate>{ page }</BlogTemplate>
);

// TODO: Вместо редиректа на 404 должна рендериться
// страница постов с заглушкой, как в остальных местах
// если эту логик убрать страница будет более оптимизирована
export const getServerSideProps: GetServerSideProps<
{ state?: RootState; },
{ theme?: PostThemeEnum; }
> = async (context) => {
  const { dispatch, store } = await createStore();
  const isLoggedIn = await checkAuthToken(context, dispatch);

  const theme = context.params?.theme;

  await dispatch(getPagingFromUrl(context));

  await dispatch(getPosts({ theme }));

  const state = store.getState();
  return { props: { state } };
};

export default Blogs;
